import { Icon, IconButton, Tooltip, Typography } from '@smartgift/frontend-toolkit';
import { Trans } from 'react-i18next';
import styled from 'styled-components';

import {
  MAX_FEATURE_NAME_LENGTH,
  MIN_LENGTH,
  OCCASION,
  expirationDuration,
  scheduleDuration
} from '@hero/constants';

const RadioSectionTitleWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 4px;
`;

const RadioLabel = styled.div`
  align-items: center;
  display: flex;
  gap: 4px;
`;

const createAutomationFormData = [
  {
    name: 'type',
    type: 'radio',
    title: <Typography variant="body2Bold">{<Trans i18nKey="selectAutomationType" />}</Typography>,
    options: [
      {
        label: (
          <RadioLabel>
            <Icon name="birthday" /> {<Trans i18nKey="birthday" />}
          </RadioLabel>
        ),
        value: OCCASION.birthday
      },
      {
        label: (
          <RadioLabel>
            <Icon name="work-anniversary" />
            {<Trans i18nKey="workAnniversary" />}
          </RadioLabel>
        ),
        value: OCCASION.workAnniversary
      }
    ]
  },
  {
    name: 'name',
    type: 'text',
    value: '',
    title: (
      <Typography
        as="div"
        variant="body2Bold"
        style={{ display: 'flex', alignItems: 'center', gap: '0.8rem' }}
      >
        {<Trans i18nKey="whatWouldYouLikeToNameIt" />}
        <Typography variant="caption1">
          (<Trans i18nKey="helpsYouIdentifyItLater" />)
        </Typography>
      </Typography>
    ),
    minLength: MIN_LENGTH,
    maxLength: MAX_FEATURE_NAME_LENGTH,
    helperTextWithValue: charCount => `${charCount}/${MAX_FEATURE_NAME_LENGTH} characters`
  }
];

const reactivateAutomationFormData = [
  {
    name: 'occasionScheduleDuration',
    type: 'radio',
    title: (
      <RadioSectionTitleWrapper>
        <Tooltip
          content={<Trans i18nKey="sendScheduleTooltipContent" />}
          tooltipConfig={{ placement: 'top' }}
        >
          <IconButton variant="link">
            <Icon name="tooltip" color="var(--color-fg-weak)" />
          </IconButton>
        </Tooltip>
        <Typography variant="body2Bold">
          <Trans i18nKey="sendSchedule" />
        </Typography>
      </RadioSectionTitleWrapper>
    ),
    options: scheduleDuration
  },
  {
    name: 'redemptionWindow',
    type: 'radio',
    title: (
      <RadioSectionTitleWrapper>
        <Tooltip
          content={<Trans i18nKey="redemptionWindowTooltipContent" />}
          tooltipConfig={{ placement: 'top' }}
        >
          <IconButton variant="link">
            <Icon name="tooltip" color="var(--color-fg-weak)" />
          </IconButton>
        </Tooltip>
        <Typography variant="body2Bold">
          <Trans i18nKey="redemptionWindow" />
        </Typography>
      </RadioSectionTitleWrapper>
    ),
    options: expirationDuration
  }
];

export { createAutomationFormData, reactivateAutomationFormData };
